import $ from 'jquery';

const validateRequiredField = function ($popup) {
    let state = true;

    const $inputs = $popup.find('input, textarea').filter(':not([disabled])').filter('[required]');

    if ($inputs.length) {

        $inputs.each((idx, input) => {
            if (!input.value.trim()) {
                state = false;
                return false;
            }
        })
    }

    return state;
}

const fields = ['email', 'question', 'g-recaptcha-response', 'slug', 'unknown'];

const getErrorElementId = function (name) {
    return '#error-' + name;
}

const cleanErrors = function () {
    $.each(fields, (i, name) => {
        $(getErrorElementId(name)).text('').hide();
    })
}

const showErrors = function (errors) {
    let found = false;
    $.each(errors, (name, messages) => {
        if ($.inArray(name, fields) !== -1) {
            found = true;
            $(getErrorElementId(name)).text(messages[0]).show();
        }
    })
    if (!found) {
        $(getErrorElementId('#error-unknown')).text('Ошибка').show();
    }
}

const askQuestion = function () {

    if ($('#ask_question').length) {
        let $askQuestion = $('#ask_question');

        $('body').on('popup.after_close', function () {
            cleanErrors();
            grecaptcha.reset();
        });

        const $submitButton = $askQuestion.find('button[type="submit"]');

        $askQuestion.on('change input', 'input, textarea', function () {
            $submitButton[validateRequiredField($askQuestion) ? 'removeAttr' : 'attr']('disabled', true);
        });

        $askQuestion.on('reset', function () {
            $submitButton[validateRequiredField($askQuestion) ? 'removeAttr' : 'attr']('disabled', true);
        })

        $askQuestion.find('form').on('submit', function (e) {
            const form = this;

            e.preventDefault();
            cleanErrors();

            $.ajax({
                url: form.action,
                type: 'post',
                data: $(form).serialize(),
                dataType: 'json',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                success: function (response) {
                    $.popup.info(['Сообщение успешно отправлено.']);
                },
                error: function (response) {
                    var data = JSON.parse(response.responseText);
                    showErrors(data.errors);
                }
            })
        });
    }
};

export default askQuestion;
